@if (compact) {
  <div class="sn-partner-inline" role="status" data-test="partner-note">
    <i class="fas fa-handshake" aria-hidden="true"></i>
    <p class="mb-0">
      @if (partnerName) {
        You signed up through <strong>{{ partnerName }}</strong>.
      }
      {{ message }}
    </p>
  </div>
} @else {
  <section class="cyber-card" aria-labelledby="sn-partner-note-title" data-test="partner-note">
    <div class="cyber-card-header">
      <div class="cyber-card-icon"><i class="fas fa-handshake" aria-hidden="true"></i></div>
      <div class="cyber-card-title">
        <h3 id="sn-partner-note-title">{{ heading }}</h3>
        <p>{{ subheading }}</p>
      </div>
    </div>
    <div class="cyber-empty-state" role="status">
      <div class="cyber-empty-icon"><i class="fas fa-handshake" aria-hidden="true"></i></div>
      <p class="cyber-empty-title">
        @if (partnerName) {
          {{ partnerName }} manages your plan
        } @else {
          Your partner manages your plan
        }
      </p>
      <p class="cyber-empty-subtitle mb-0">{{ message }}</p>
    </div>
  </section>
}
